'use client';

import React, { createContext, useRef, ReactNode, useState } from 'react';
import { ZipCodeInputRefHandle } from './ZipCodeInput';
// import { ModalitySectionRef } from './ModalitySection';
// import { HSASectionRef } from './HSASection';

// Define the context type
interface ZipCodeContextType {
  zipCodeInputRef: React.RefObject<ZipCodeInputRefHandle | null> | null;
  modalitySectionRef?: React.RefObject<HTMLDivElement | null> | null;
  hsaSectionRef?: React.RefObject<HTMLDivElement | null> | null;
  setModalitySectionRef?: (
    ref: React.RefObject<HTMLDivElement | null>,
  ) => void;
  setHsaSectionRef?: (ref: React.RefObject<HTMLDivElement | null>) => void;
}

// Create the context with a default null value
export const ZipCodeContext = createContext<ZipCodeContextType>({
  zipCodeInputRef: null,
});

// Provider props type
interface ZipCodeProviderProps {
  children: ReactNode;
}

// Provider component
export const ZipCodeProvider: React.FC<ZipCodeProviderProps> = ({
  children,
}) => {
  // Create a ref for the ZIP code input component
  const zipCodeInputRef = useRef<ZipCodeInputRefHandle | null>(null);
  const [modalitySectionRef, setModalitySectionRef] =
    useState<React.RefObject<HTMLDivElement | null> | null>(null);
  const [hsaSectionRef, setHsaSectionRef] =
    useState<React.RefObject<HTMLDivElement | null> | null>(null);

  // Create the context value
  const contextValue: ZipCodeContextType = {
    zipCodeInputRef,
    modalitySectionRef,
    hsaSectionRef,
    setModalitySectionRef,
    setHsaSectionRef,
  };

  return (
    <ZipCodeContext.Provider value={contextValue}>
      {children}
    </ZipCodeContext.Provider>
  );
};
